
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PulsarBeamEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             const angle = curTime * 5;
             const beamWidth = (20 + Math.sin(curTime * 10) * 10) * scale;
             
             ctx.save();
             ctx.rotate(angle);
             ctx.globalAlpha *= 0.6 / (layerIndex + 1);
             
             // Two opposite beams
             ctx.fillRect(-width * 2, -beamWidth/2, width * 4, beamWidth);
             
             // Central star
             const r = 50 * scale * (1 + Math.sin(curTime * 10) * 0.2);
             const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(1, 'transparent');
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.arc(0, 0, r, 0, Math.PI * 2);
             ctx.fill();
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
